import React from 'react'
import styled from 'styled-components'
import api from '../../../api'
import FailureIcon from '../../../assets/icons/JSX/FailureIcon'
import SuccessIcon from '../../../assets/icons/JSX/SuccessIcon'
import Loader from '../../../components/Loader'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
//
//
const VerifyEmail = () => {
  //
  const { t } = useTranslation()
  //
  const PathName = window.location.pathname
  const IncomingEmail = PathName.split('/')[2]
  const IncomingToken = PathName.split('/')[3]
  //
  const {
    data: verifyResponse,
    isLoading: isVerifyLoading,
    error,
  } = api.useVerifyEmailQuery({
    email: IncomingEmail,
    token: IncomingToken,
  })
  //
  //
  return isVerifyLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('clickToVerify')}</title>
        <meta name="description" content={`${t('clickToVerify')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {error && (
        <Block>
          <FailureIcon />
          {/* @ts-ignore */}
          <span>{error?.data?.message}</span>
        </Block>
      )}
      {/*  */}
      {/*  */}
      {verifyResponse && (
        <Block>
          <SuccessIcon />
          <span>{verifyResponse.message}</span>
        </Block>
      )}
    </Wrapper>
  )
}
//
// styles
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 70vw;
  margin-inline: auto;
`
const Block = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  /*  */
  svg {
    margin-bottom: 20px;
    height: 100px;
    width: fit-content;
  }
`
//
//
export default VerifyEmail
